var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container-fluid"},[_c('EServiceDocDetailReferral',{attrs:{"appointment":_vm.appointment,"referral":_vm.appointment.referral}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }